import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=6fff1ad2&scoped=true"
import script from "./Gantt.vue?vue&type=script&lang=js"
export * from "./Gantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff1ad2",
  null
  
)

export default component.exports